import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useGetExpenseCategoriesQuery = (enabled = true) => {
  const { data, isPending, isError } = useQuery({
    queryKey: ["expenseCategories"],
    queryFn: () => api.get(API_ROUTES.GET_EXPENSE_CATEGORIES),
    staleTime: 5 * 60 * 1000, // categories change rarely
    enabled,
  });
  return { data: data?.data?.data ?? [], isPending, isError };
};

export const useCreateExpenseCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post(API_ROUTES.CREATE_EXPENSE_CATEGORY, data),
    onSuccess: () => {
      showToast("success", "Category created");
      queryClient.invalidateQueries({ queryKey: ["expenseCategories"] });
    },
    onError: (err) =>
      showToast("error", err?.response?.data?.message || "Failed to create category"),
  });
};

export const useUpdateExpenseCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) =>
      api.put(`${API_ROUTES.UPDATE_EXPENSE_CATEGORY}/${id}`, data),
    onSuccess: () => {
      showToast("success", "Category updated");
      queryClient.invalidateQueries({ queryKey: ["expenseCategories"] });
    },
    onError: (err) =>
      showToast("error", err?.response?.data?.message || "Failed to update category"),
  });
};

export const useDeleteExpenseCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`${API_ROUTES.DELETE_EXPENSE_CATEGORY}/${id}`),
    onSuccess: () => {
      showToast("success", "Category deleted");
      queryClient.invalidateQueries({ queryKey: ["expenseCategories"] });
    },
    onError: () => showToast("error", "Failed to delete category"),
  });
};
